import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const key = import.meta.env.VITE_SUPABASE_ANON_KEY

/** False when the build is missing its Supabase config. */
export const isConfigured = Boolean(url && key)

if (!isConfigured) {
  console.error(
    'Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY — ' +
    'sign-in and league data are unavailable in this build.',
  )
}

/**
 * createClient() throws on an empty URL, and that throw happens at module load,
 * which takes the entire bundle down — including the marketing pages that need
 * no database at all. A missing env var should cost you sign-in, not the whole
 * site, so fall back to a syntactically valid placeholder and let individual
 * calls fail instead.
 */
export const supabase = createClient(
  url || 'https://placeholder.supabase.co',
  key || 'placeholder-anon-key',
  { auth: { persistSession: true, autoRefreshToken: true } },
)
